import { GET_SIGNATURE_REQUEST, SIGN_SIGNATURE_REQUEST } from './signatureRequest.type';

export const getSignatureRequest = (token) => {
    return {
        type: GET_SIGNATURE_REQUEST,
        payload: { token },
    };
};

export const signSignatureRequest = (token, file, signorId, confirmed) => {
    return {
        type: SIGN_SIGNATURE_REQUEST,
        payload: { token, file, signorId, confirmed },
    };
};
